type Strings = {
  subtitle: string;
  hero_title: string;
  hero_body: string;
  card_apk: string;
  card_obb: string;
  no_file_selected: string;
  selected_label: (name: string, sizeMb: string) => string;
  pick_file: string;
  format_apk: string;
  format_obb: string;
  drop_zone_apk: string;
  drop_zone_obb: string;
  install_apk: string;
  install_apk_obb: string;
  install_subtitle: string;
  phase_running: string;
  phase_done: string;
  phase_error: (msg: string) => string;
  download_apk: (pkg: string) => string;
  reset: string;
  how_it_works_title: string;
  how_it_works_body: string;
  caveat_title: string;
  caveat_body: string;
  android_app_link: string;
  source_link: string;
};

const en: Strings = {
  subtitle: "Browser version",
  hero_title: "Patch a game APK + OBB. In your browser.",
  hero_body:
    "Drop the game's APK and its OBB. The patcher rewrites the APK so the OBB rides inside it and ends up in the right Android folder on first launch. Nothing is uploaded — every byte stays in your browser.",
  card_apk: "APK",
  card_obb: "OBB (optional)",
  no_file_selected: "No file selected",
  selected_label: (name, size) => `Selected · ${name} · ${size} MB`,
  pick_file: "Choose a file",
  format_apk: "Supported · .apk",
  format_obb: "Supported · .obb",
  drop_zone_apk: "Drop or pick an .apk",
  drop_zone_obb: "Drop or pick an .obb",
  install_apk: "Patch APK",
  install_apk_obb: "Patch APK + OBB",
  install_subtitle: "The OBB will be injected on first launch of the game",
  phase_running: "Working…",
  phase_done: "Patched APK ready. Download below, then install on your device.",
  phase_error: (msg) => `Failed: ${msg}`,
  download_apk: (pkg) => `Download ${pkg}.patched.apk`,
  reset: "Start over",
  how_it_works_title: "How it works",
  how_it_works_body:
    "The OBB is bundled inside the patched APK. A tiny invisible component injected next to the game extracts it on first launch — directly from inside the game's process, where every Android version allows writing to the OBB folder.",
  caveat_title: "Caveat",
  caveat_body:
    "The game is re-signed with the hub key, so Play Store updates are no longer possible and online anti-cheat will reject it. Single-player and offline games run normally.",
  android_app_link: "Get the Android app",
  source_link: "Source on GitHub",
};

const fr: Strings = {
  subtitle: "Version navigateur",
  hero_title: "Patche un APK + OBB. Dans ton navigateur.",
  hero_body:
    "Glisse l'APK du jeu et son OBB. Le patcheur réécrit l'APK pour embarquer l'OBB dedans, et elle atterrit toute seule dans le bon dossier Android au premier lancement. Rien n'est uploadé — tout reste dans ton navigateur.",
  card_apk: "APK",
  card_obb: "OBB (optionnel)",
  no_file_selected: "Aucun fichier sélectionné",
  selected_label: (name, size) => `Sélectionné · ${name} · ${size} Mo`,
  pick_file: "Choisir un fichier",
  format_apk: "Format supporté · .apk",
  format_obb: "Format supporté · .obb",
  drop_zone_apk: "Glisse ou choisis un .apk",
  drop_zone_obb: "Glisse ou choisis un .obb",
  install_apk: "Patcher l'APK",
  install_apk_obb: "Patcher APK + OBB",
  install_subtitle: "L'OBB sera injectée au premier lancement du jeu",
  phase_running: "Traitement…",
  phase_done:
    "APK patchée prête. Télécharge-la ci-dessous, puis installe-la sur ton téléphone.",
  phase_error: (msg) => `Échec : ${msg}`,
  download_apk: (pkg) => `Télécharger ${pkg}.patched.apk`,
  reset: "Recommencer",
  how_it_works_title: "Comment ça marche",
  how_it_works_body:
    "L'OBB est embarquée DANS l'APK. Un mini composant invisible injecté à côté du jeu la copie au premier lancement — depuis le processus du jeu, où Android autorise toujours l'écriture dans le dossier OBB.",
  caveat_title: "Conséquence",
  caveat_body:
    "Le jeu est re-signé avec la clé du hub. Plus de mises à jour Play Store et tout anti-cheat en ligne refusera l'install. Les jeux solo et hors-ligne tournent normalement.",
  android_app_link: "Récupérer l'app Android",
  source_link: "Code source sur GitHub",
};

export function getStrings(): Strings {
  const lang = (navigator.language || "en").toLowerCase();
  return lang.startsWith("fr") ? fr : en;
}
